/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	MetaLocationSearchCountriesQueryParams,
	MetaLocationSearchCountriesResponse,
} from '../types/MetaLocationSearchCountries'

/**
 * GET /meta/countries
 * @see backend/nexus/modules/MetaAd/Http/Controllers/MetaLocationController.php MetaLocationController::searchCountries
 */
export async function metaLocationSearchCountries(
	params?: MetaLocationSearchCountriesQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<MetaLocationSearchCountriesResponse>> {
	return axiosInstance.get('/meta/countries', { params, ...config })
}
